module.exports = __webpack_public_path__ + "img/num_6.961dfc92.png";